import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {

    static componentName = 'ErrorComponent';
    post: any;

    constructor() {}

    ngOnInit() {
        // :)
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/error/error.component.ts